import React from 'react'
import { Card, Table, Pagination } from 'antd'
import datatable from '../../../utils/tableData'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'
import api_url from '../../../utils/requestApi'

class SendCoinHistory extends React.Component{
    constructor(props){
        super(props)
        this.tableDataFetch = this.tableDataFetch.bind(this)
    }
    state={
        tableData: [],
        empty: true,
        loading: false,
        current_page: 1,
        page_size: 10,
        total_page: 1
    }
    componentDidMount(){
        this.tableDataFetch()
    }
    tableDataFetch(current_page = this.state.current_page){
        let serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
            serverApi.deposit_history(api_url.send_coin_history+current_page+'/'+this.state.page_size, (returnData) => {
                if(returnData.success == '1'){
                    this.setState({
                        empty: false,
                        tableData: this.processData(returnData.data),
                        current_page: returnData.current_page,
                        total_page: returnData.total_page,
                        total_page: returnData.total
                    })
                }else{
                    this.setState({
                        empty: true
                    })
                }
                this.setState({loading: false})
            })
        })
    }
    processData = (response) => {
        response.map((obj, i) => {
            obj.key = i;
            obj.serial = this.state.current_page == 1 ? i+1 : ((this.state.current_page - 1) * this.state.page_size) + i + 1;
            obj.time = obj.time.replace(' ', '_');
            obj.amount = obj.amount.toFixed(2);
            obj.interest = obj.interest+'%';
            obj.from_idd = (obj.from_idd == this.props.userData.info.userId)?'Me':obj.from_idd;
            obj.to_idd = (obj.to_idd == this.props.userData.info.userId)?'Me':obj.to_idd;
        })
        return response
    }
    render(){
        return(
            <Card>
                <u className="ml-5"><h5>Send Coin History</h5></u>
                <div className="table-container">
                    <Table
                        loading={this.state.loading}
                        bordered={true}
                        tableLayout="auto"
                        size="small"
                        dataSource={this.state.tableData}
                        pagination={false}
                        columns={datatable.send_coin}

                    />
                    <div style={{marginTop:"10px",float:"right"}}>
                        <Pagination 
                            size="small"
                            defaultCurrent={this.state.current_page}
                            current={this.state.current_page}
                            pageSize={this.state.page_size}
                            total={this.state.total_page}
                            onChange={(page) => {
                                this.setState({current_page: page}, () => {
                                    this.tableDataFetch()
                                })
                            }}
                        />
                    </div>
                </div>
            </Card>
        )
    }
}

export default SendCoinHistory;